import { generateMedia } from 'styled-media-query';

/**
 * breakpoint.greaterThan('200px')
 * https://github.com/morajabi/styled-media-query
 */
export const screenSize = {
	superlarge: 1400, // breakpoint.greaterThan('superlarge')

	largescreen: 1200, // breakpoint.greaterThan('largescreen')

	upper1090: 1090, // breakpoint.greaterThan('upper1090')

	desktop: 992, // breakpoint.greaterThan('desktop')

	underdesktop: 991, // breakpoint.lessThan('underdesktop')

	tablet: 767, // breakpoint.greaterThan('tablet')

	undertablet: 767, // breakpoint.lessThan('undertablet')

	// breakpoint.between('uppermobile', 'tablet')

	uppermobile: 415, // breakpoint.greaterThan('uppermobile')

	mobile: 414, // breakpoint.lessThan('mobile')

	smallmobile: 320, // breakpoint.lessThan('smallmobile')
};

const screenSizePX = {};
Object.keys(screenSize).forEach((key) => {
	const value = screenSize[key];
	screenSizePX[key] = `${value}px`;
});
export const breakpoint = generateMedia(screenSizePX);
